import { Link } from "react-router-dom";
import expertConsuling from "../../assets/ExpertConsuling.png"
export default function ExpertConsulting() {
  return (
    <>
      {/* Spacer for sticky header */}
      <div  /> {/* Header spacing style={{ height: 72 }}*/}

      {/* Hero Section */}
      <section className="py-5 bg-white position-relative overflow-hidden">
        <div className="container">
          <div className="row align-items-center gx-5" data-aos="fade-right">
            <div className="col-md-7">
              <h1
                className="display-5 fw-bold mb-3"
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  letterSpacing: ".5px",
                  color: "#2e3d9c"
                }}
              >
                <span
                  style={{
                    background: "linear-gradient(90deg,#6B46C1,#D53F8C 85%)",
                    color: "transparent",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text"
                  }}
                >
                  Expert Tax Consulting<br />
                </span>
                & IRS Audit Representation
              </h1>
              <p className="fs-5 text-secondary mb-1" style={{ maxWidth: 560 }}>
                If you're facing an audit, our experienced tax professionals will represent you before the IRS.
                We'll work to resolve the audit quickly and efficiently, ensuring you receive a fair outcome.
              </p>
            </div>
            <div className="col-md-5 text-center d-none d-md-block" data-aos="fade-left">
              <img
                src={expertConsuling}
                alt="Audit Consulting"
                className="img-fluid rounded shadow"
                style={{ maxHeight: 280, objectFit: "cover" }}
              />
            </div>
          </div>
        </div>
        {/* Top decorative gradient blob */}
        {/* <div
          aria-hidden="true"
          className="position-absolute top-0 end-0 opacity-15"
          style={{
            width: 120,
            height: 120,
            background: "linear-gradient(135deg,#6b46c1,#d53f8c)",
            borderRadius: "50%",
            filter: "blur(14px)",
            zIndex: 0
          }}
        /> */}
      </section>

      {/* Audit Representation & Defense */}
      <section className="py-5" style={{ background: "#f9fafe" }}>
        <div className="container">
          <h2
            className="fw-bold audit-gradient mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Comprehensive Audit Solutions
          </h2>
          <div className="row g-4">
            {[
              {
                icon: "bi-shield-lock",
                iconColor: "#6B46C1",
                title: "Audit Defense",
                desc:
                  "We skillfully defend your interests during every stage of an audit—protecting your rights and minimizing your liabilities.",
              },
              {
                icon: "bi-bank2",
                iconColor: "#224eae",
                title: "IRS Representation",
                desc:
                  "Our experts communicate and negotiate directly with the IRS, ensuring all matters are presented accurately and in your best interest.",
              },
              {
                icon: "bi-patch-check-fill",
                iconColor: "#D53F8C",
                title: "Audit Resolution",
                desc:
                  "We achieve prompt resolutions—clarifying disputed issues, handling appeals, and securing fair outcomes for you or your business.",
              },
            ].map(({ icon, iconColor, title, desc }) => (
              <div className="col-md-4" key={title}>
                <div className="card border-0 shadow h-100 text-center p-4 rounded-4">
                  <span
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 icon-60"
                    style={{ background: "#f1f1fe", margin: "0 auto" }}
                  >
                    <i className={`bi ${icon} fs-2`} style={{ color: iconColor }}></i>
                  </span>
                  <h5
                    className="fw-semibold mb-2"
                    style={{ color: iconColor }}
                  >
                    {title}
                  </h5>
                  <p className="small text-secondary mb-0">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bookkeeping & Accounting Services */}
      <section className="py-5 bg-white">
        <div className="container">
          <h2
            className="fw-bold mb-4 audit-gradient"
            style={{
              fontFamily: "'Poppins', sans-serif"
            }}
          >
            Bookkeeping &amp; Accounting Services
          </h2>
          <p className="fs-5 text-secondary" style={{ maxWidth: 730 }}>
            Our bookkeeping and accounting services are designed to help you manage your finances effectively.
            We'll work with you to develop a customized financial plan that meets your unique needs and goals.
          </p>
          <div className="row mt-4 g-4">
            {[
              {
                icon: "bi-file-earmark-bar-graph",
                title: "Financial Statement Preparation",
                desc: "Timely and accurate statements for confident business decisions and compliance.",
                iconColor: "#6B46C1",
                bg: "#f2e7fa"
              },
              {
                icon: "bi-bar-chart-line",
                title: "Budgeting & Forecasting",
                desc: "Data-driven budgeting and forecasting for greater control over business growth.",
                iconColor: "#224eae",
                bg: "#e0f0ff"
              },
              {
                icon: "bi-arrow-left-right",
                title: "Accounts Payable & Receivable",
                desc: "Efficient management of invoices, collections, and payments to optimize cash flow.",
                iconColor: "#D53F8C",
                bg: "#fae1f2"
              },
              {
                icon: "bi-credit-card-2-front",
                title: "Payroll Processing",
                desc: "Accurate, timely payroll for employees, including compliance with all tax regulations.",
                iconColor: "#31926A",
                bg: "#e6f7f3"
              },
            ].map(({ icon, iconColor, title, desc, bg }) => (
              <div className="col-md-6 col-lg-3" key={title}>
                <div className="card border-0 shadow-sm h-100 text-center p-4 rounded-4">
                  <span
                    className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3 icon-54"
                    style={{
                      background: bg,
                      margin: "0 auto"
                    }}
                  >
                    <i className={`bi ${icon} fs-2`} style={{ color: iconColor }}></i>
                  </span>
                  <h6 className="fw-semibold mb-2" style={{ color: iconColor }}>{title}</h6>
                  <p className="small text-secondary mb-0">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-12 bg-gradient-to-r from-violet-700 to-pink-600 text-white text-center position-relative overflow-hidden">
        <div className="container max-w-3xl position-relative z-10">
          <h2
            className="text-4xl md:text-5xl font-extrabold mb-6 leading-tight"
            style={{ fontFamily: "'Poppins', sans-serif", color: "#272424ff" }}
          >
            Ready to Get Expert Help?
          </h2>
          <p className="text-lg md:text-xl mb-4 max-w-xl mx-auto opacity-90">
            Contact Nexen Consulting for a confidential consultation with our seasoned tax professionals—guiding you from audit defense to streamlined accounting.
          </p>
          <div className="d-flex justify-content-center">
            <Link
              to="/contact"
              className="btn btn-lg rounded-pill fw-bold text-white px-5 py-3"
              style={{
                background: 'linear-gradient(90deg, #6B46C1, #D53F8C)',
                boxShadow: '0 4px 15px rgba(213,63,140,0.45)',
                transition: 'transform 0.3s, box-shadow 0.3s',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'scale(1.05)';
                e.currentTarget.style.boxShadow = '0 8px 30px rgba(213,63,140,0.7)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'scale(1)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(213,63,140,0.45)';
              }}
            >
              Get In Touch
            </Link>
          </div>
        </div>
        {/* Decorative blurred circles */}
        <div
          aria-hidden="true"
          className="position-absolute top-[-60px] left-[-60px] w-48 h-48 bg-pink-400 rounded-full filter blur-3xl opacity-40"
        />
        <div
          aria-hidden="true"
          className="position-absolute bottom-[-50px] right-[-50px] w-64 h-64 bg-violet-700 rounded-full filter blur-3xl opacity-30"
        />
      </section>

      {/* Custom CSS */}
      <style>{`
        .audit-gradient {
          background: linear-gradient(90deg,#6B46C1,#D53F8C 85%);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          -webkit-text-fill-color: transparent;
        }
      `}</style>

      {/* Bootstrap Icons CDN (in case not loaded globally) */}
      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.10.3/font/bootstrap-icons.css"
      />

    </>
  );
}
